import { createSafeStorage } from '../browserStorage';

export const localStorage = createSafeStorage('localStorage');
